import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { patchImageSlider } from 'redux/image-sliders/actions';

import { Dropdown } from 'semantic-ui-react';

import './InstagramSliderOptionDropdown.css';


function InstagramSliderOptionDropdown(props) {
  const { item, patchImageSlider, label, options, initialValue, parameter } = props;

  const [currentValue, setCurrentValue] = useState(initialValue);

  return (
    <div className="instagram-slider-option-dropdown__component">
      <div className="label">{label}</div>
      <Dropdown
        fluid
        selection
        value={currentValue}
        options={options}
        onChange={(_e, data) => {
          setCurrentValue(data.value);
          const form = new FormData();
          form.append(parameter, data.value);
          patchImageSlider(item.id, form);
        }}
      />
    </div>
  );
}

InstagramSliderOptionDropdown.propTypes = {
  patchImageSlider: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape).isRequired,
  initialValue: PropTypes.number.isRequired,
  parameter: PropTypes.string.isRequired,
};

export default connect(
  null,
  {
    patchImageSlider,
  },
)(InstagramSliderOptionDropdown);
